import React from "react";
// import { Navigate } from "react-router-dom";
import ContainerRedirect from "../../../pages/lib/page-redirect";

const UserListComponent = React.lazy(
  () => import("../../../components/tools/users/components/list/page")
);

export const toolsRoute = [
  {
    path: "users",
    element: <UserListComponent />,
  },
{
  path: "",
  element: <ContainerRedirect elroute="/tools"/>
},
];
